import { FC, useCallback } from 'react';
import {
  AdvertType,
  AdvertCard,
  AdvertDetailType,
  useAdvertContactsDataControl,
} from '@edikk-edikk/ui';
import { useClickLogicForGuest } from '#advert/components/advert-card/hooks/use-click-logic-for-guest';

type PropsType = {
  advert: AdvertType;
  index?: number;
  additionalClassName?: string;
};

const AdvertCardWrapper: FC<PropsType> = ({
  advert,
  index = null,
  additionalClassName = null,
}) => {
  const clickLogicForGuest = useClickLogicForGuest();
  const { setContactData, removeContactData } = useAdvertContactsDataControl();

  const clickLogicForFavoriteToggle = useCallback(async (id: number, isFavorite: boolean): Promise<void> => {
    clickLogicForGuest(id, isFavorite);
    return Promise.resolve();
  }, [clickLogicForGuest]);

  const handlerBottomSheetHideEnd = useCallback(() => {
    removeContactData();
  }, [removeContactData]);

  const handlerDetailLoadedSuccess = useCallback((data: AdvertDetailType) => {
    setContactData(data.contactData);
  }, [setContactData]);

  return (
    <AdvertCard
      key={advert.id}
      index={index}
      advert={advert}
      additionalClassName={additionalClassName}
      clickLogicForFavoriteToggle={clickLogicForFavoriteToggle}
      onDetailLoadedSuccess={handlerDetailLoadedSuccess}
      onBottomSheetHideEnd={handlerBottomSheetHideEnd}
    />
  );
};

export { AdvertCardWrapper };
